<template>
  <router-view></router-view>
</template>

<script>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

import { VueGtmUtils } from '@azimut-mfe/styleguide'

export default {
  name: 'App',
  setup() {
    const gtm = VueGtmUtils.useGtm()
    const store = useStore()

    const currentUserSub = computed(() => {
      return store.state.user.sub
    })

    watch(currentUserSub, (value) => {
      gtm.trackEvent({
        user_id: value,
        organizationId: undefined,
      })
    })
  },
}
</script>
